import { render, staticRenderFns } from "./ReasonConsultationPage.vue?vue&type=template&id=19b87562"
import script from "./ReasonConsultationPage.vue?vue&type=script&lang=js"
export * from "./ReasonConsultationPage.vue?vue&type=script&lang=js"
import style0 from "./ReasonConsultationPage.vue?vue&type=style&index=0&id=19b87562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports